import { Link } from 'react-router-dom';
import type { PublicJobSummary } from '@absurd-careers/shared';
import { formatCompensation, formatEmploymentType, formatWorkplaceType } from '~/lib/format.js';

/**
 * One opening as a full-width row rather than a card: it keeps the list scannable
 * and lets the type carry the design, which is what the studio's own site does.
 */
export function JobRow({ job }: { job: PublicJobSummary }) {
  const compensation = formatCompensation(job.compensation);

  return (
    <li className="border-t border-line">
      <Link
        to={'/jobs/' + job.slug}
        className="group flex flex-col gap-2 px-1 py-6 transition-colors hover:bg-surface/70 sm:flex-row sm:items-baseline sm:justify-between sm:gap-8"
      >
        <span className="min-w-0">
          <span className="block font-heading text-xl font-semibold tracking-[-0.03em] text-heading transition-colors group-hover:text-primary sm:text-2xl">
            {job.title}
          </span>
          <span className="mt-1 block text-sm text-muted">
            {job.department} · {job.locationText}
          </span>
        </span>

        <span className="flex shrink-0 flex-wrap items-baseline gap-x-3 gap-y-1 text-sm text-muted">
          <span>{formatWorkplaceType(job.workplaceType)}</span>
          <span aria-hidden="true" className="text-line-strong">
            /
          </span>
          <span>{formatEmploymentType(job.employmentType)}</span>
          {compensation ? (
            <>
              <span aria-hidden="true" className="text-line-strong">
                /
              </span>
              <span>{compensation}</span>
            </>
          ) : null}
        </span>
      </Link>
    </li>
  );
}
